import { Injectable } from '@angular/core';
import { NEWS, NEWS_CENTER } from '@core/constants/api.constants';
import { News } from '@shared/models';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpService } from '../http/http-api';

@Injectable({
  providedIn: 'root'
})
export class NewsService {

  constructor(
    private httpService: HttpService
  ) { }

  public newsCount$: BehaviorSubject<number> = new BehaviorSubject(0)
  public news$: BehaviorSubject<any> = new BehaviorSubject(null);
  public newsForRead$: BehaviorSubject<any> = new BehaviorSubject(null);

  getNewsCounts(): Observable<number> {
    return this.newsCount$.asObservable();
  }

  setNewsCount(value: number) {
    this.newsCount$.next(value);
  }

  getNew(): Observable<any> {
    return this.news$.asObservable();
  }

  setNews(value: any) {
    this.news$.next(value);
  }

  setNewsForRead(value: any) {
    this.newsForRead$.next(value);
  }

  getNewForRead(): Observable<any> {
    return this.newsForRead$.asObservable();
  }

  async getNews(offset: number = 0, limit: number = 0, sortBy: string = 'id:asc', subject?: string): Promise<any> {
    let params: any | null = {}

    if (limit != -1) { params.limit = limit; params.offset = offset }
    if (sortBy) { params.sortBy = sortBy }
    if (subject) { params.subject = subject }

    this.httpService.get(NEWS.GET_GLOBAL_NEWS, params).then(result => {
      this.setNews(result);
    });
  }

  markAllNewsRead() {
    return this.httpService.putAsObservable(NEWS_CENTER.MARK_ALL_NEWS_AS_READ, null);
  }


  async modifyNewsStatus(messageIds: Array<string>) {
    let strNewIds = messageIds.join(',');
    // return this.httpService.post(NEWS.POST(strNewIds), body);
    return this.httpService.put(NEWS.POST(strNewIds), null);
  }

  async modifyGlobalNewsStatus(messageIds: Array<string>) {
    let strNewIds = messageIds.join(',');
    // return this.httpService.post(NEWS.POST(strNewIds), body);
    return this.httpService.put(NEWS.POST_GLOBAL(strNewIds), null);
  }



  async getNewsCount() {
    this.httpService.get(NEWS.GET_GLOBAL_NEWS_COUNT, undefined, { 'skip': true }).then(result => {
      this.setNewsCount(result);
    });
  }
}
